import { ajax } from './functions/ajax';
import { isObject } from './functions/obj';

document.addEventListener('DOMContentLoaded', (event) => {

    loadVideoInformation();
});

function loadVideoInformation() {
    const containers = Array.from(getVideoContainer());

    containers.forEach((container) => {
        const id = getVideoId(container);
        const data = getAdditionalData(container, id);
    });
}

function getVideoContainer() {
    return document.getElementsByClassName('videobeitrag');
}

function getVideoId(container) {
    return container.dataset.videoId;
}

function getAdditionalData(container, id) {

    ajax({
        url: getAdditionalVideoUrl(),
        data: {
            id
        },
        success: (response) => {
            // response in Container laden
            response = JSON.parse(response);

            // Die zurückgelieferten Daten einfügen
            if (isObject(response)) {
                if (response.statistics.items) {
                    updateStatistics(response.statistics.items[0].statistics, container);
                } else {
                    updateBackground(container.querySelector('.views'));
                    updateBackground(container.querySelector('.likes'));
                }
            }
        },
        error: () => {},
    });
}

function getAdditionalVideoUrl() {
    const container = Array.from(getAdditionalVideoUrlContainer());

    return container[0].dataset.additionalVideoDataUrl;
}

function getAdditionalVideoUrlContainer() {
    return document.getElementsByClassName('videoportal');
}

function updateStatistics(statistics, container) {
    const viewNumber = container.querySelector('.views .number');
    const likeNumber = container.querySelector('.likes .number');

    if (viewNumber) {
        updateViewNumber(statistics, viewNumber, container);
    }
    if (likeNumber) {
        updateLikeNumber(statistics, likeNumber, container);
    }
}

/**
 * Writes viewnumber in
 *
 * @param array statistics
 * @param  HTML-element viewNumber
 */
function updateViewNumber(statistics, viewNumberContainer, container) {
    viewNumberContainer.innerHTML = '<i class="fa fa-eye" style="color: @grey-light;" aria-hidden="true"></i>' + ' ' + parseInt(statistics.viewCount, 10).format(0) + ' Aufrufe';
}

/**
 * Sets background of container to transparent
 *
 * @param HTML-element container
 */
function updateBackground(container)
{
    container.setAttribute('style', 'background-color:transparent !important;');
}

function updateLikeNumber(statistics, likeNumberContainer, container)
{
    likeNumberContainer.innerHTML = '<i class="fa fa-thumbs-up" style="color: @grey-light;" aria-hidden="true"></i>' + ' ' + parseInt(statistics.likeCount, 10).format(0) + ' Likes';
}
